<div class="ss" [class.ss--open]="open" [class.ss--disabled]="disabled">
  <button
    type="button"
    class="ss__trigger"
    (click)="toggle()"
    [attr.aria-expanded]="open"
    [disabled]="disabled"
  >
    <span
      class="ss__value"
      [class.ss__value--placeholder]="!selectedLabel"
    >{{ selectedLabel || placeholder }}</span>
    <mat-icon class="ss__chevron">expand_more</mat-icon>
  </button>

  <div class="ss__panel" *ngIf="open">
    <div class="ss__search-wrap">
      <mat-icon class="ss__search-icon">search</mat-icon>
      <input
        #searchInput
        type="text"
        class="ss__search"
        placeholder="Search…"
        [(ngModel)]="query"
        [ngModelOptions]="{ standalone: true }"
        (keydown.enter)="showCustomRow ? selectCustom() : null"
        autocomplete="off"
      />
    </div>

    <p class="ss__hint" *ngIf="loading">Loading…</p>

    <div class="ss__list">
      <button
        type="button"
        class="ss__item ss__item--empty"
        *ngIf="emptyLabel"
        (click)="select(null)"
      >{{ emptyLabel }}</button>

      <button
        type="button"
        class="ss__item"
        *ngFor="let o of filtered; trackBy: trackByValue"
        [class.ss__item--active]="o.value === selectedValue"
        (click)="select(o.value)"
      >
        <span class="ss__item-label">{{ o.label }}</span>
        <span class="ss__item-sub" *ngIf="o.sub">{{ o.sub }}</span>
      </button>

      <!-- Free-text fallback row -->
      <button
        type="button"
        class="ss__item ss__item--custom"
        *ngIf="showCustomRow"
        (click)="selectCustom()"
      >
        <mat-icon>add</mat-icon>
        <span class="ss__item-label">Use “{{ query.trim() }}”</span>
      </button>

      <p class="ss__empty" *ngIf="!filtered.length && !showCustomRow && !loading">No matches</p>
    </div>

    <button
      type="button"
      class="ss__add"
      *ngIf="addLabel"
      (click)="onAddClick($event)"
    >
      <mat-icon>add</mat-icon>
      <span>{{ addLabel }}</span>
    </button>
  </div>
</div>
